<template>
    <v-combobox
        v-model="modelValue"
        :items="options"
        color="primary"
        variant="underlined"
        :class="classField"
        :style="`font-size: ${fontSize}; border-radius:0;`"
        item-text="value"
        item-title="value"
        :label="label"
        persistent-hint
        hide-details
        :return-object="false"
        @keyup="updateValue($event.target.value)"
    >
      <template v-slot:item="{ props, item }">
        <v-list-item v-bind="props">
          <template #title>
          {{ item.raw.name }}: {{ item.raw.value }}

          </template>
        </v-list-item>
      </template>
    </v-combobox>
</template>
<script>
export default {
  name: 'ComboBoxDataField',
  props: {
    parameter: {required: true},
    options: {required: true},
    item: {required: true},
    label: {require: true},
    classField: {required: false},
    fontSize: {required: false, default: "14px"},
  },
  computed: {
    modelValue: {
      get: function () {
        let arr = this.parameter.split('.');
        let value = this.item
        for (var i = 0; i < arr.length; i++) {
            if (value)
            value = value[arr[i]];
        }
        return value
      },
      set: function (value) {
        this.updateValue(value)
      },
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('update');
      this.$emit('set', {item: this.item, value: value !== '' ? value : null, parameter: this.parameter});
    }
  }
}
</script>